import { Pipe, PipeTransform, SecurityContext, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { markdownToHtml } from "../utils/markdown.util";

/**
 * Renders markdown as sanitized HTML.
 * Usage: `[innerHTML]="acceptanceCriteria | markdown"`
 */
@Pipe({
  name: "markdown",
  standalone: true,
})
export class MarkdownPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: unknown): SafeHtml {
    const html = markdownToHtml(value);
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, html) ?? "";
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
